<template>
  <div class="nav">
    <!-- <div class="nav01">
     <div class="search">
        <el-input placeholder="找大学/查专业/搜文章/看职业" class="input"></el-input>
        <img src="../../../assets/search.png" class="img" alt="">
     </div>
    </div> -->

    <div class="nav02">
         <img src="@/assets/kuaijie/kuaijie.png"  style="margin-top: 30px;" class="kuaijie" alt="">
         <div class="nav02s">
             <div class="navback" v-for="(item,i) in kuaijieArr" :key="i" @click="routers(item)">
                <img :src="require('@/assets/kuaijie/kj' + (i+1) + '.png')" alt="">
                {{item.title}}
             </div>
         </div>
    </div>

  </div>
</template>

<script>
  export default {
      data(){
        return{
           kuaijieArr:[
            {title:"查院校",url:"/School"},
            {title:"查专业",url:"/Major"},
            {title:"查位次",url:"/comprehensive?n=12"},
            {title:"填报与录取时间",url:"/comprehensive?n=16"},
            {title:"查招生简章",url:"/School?n=zhaosheng"},
            {title:"批次线查询",url:"/comprehensive?n=13"},
            {title:"院校排行",url:"/School?n=paihang"},
            {title:"专业排行",url:"/comprehensive?n=11"},
            {title:"往年征集",url:"/comprehensive?n=14"},
            {title:"新增院校专业",url:"/Volunteer?n=3"},
            {title:"中外合作院校",url:"/School?n=zhongwai"},
            {title:"推免院校",url:"/School?n=tuimian"}
           ],
        }
      },
      methods:{
         routers(item){
          const routerUrl = this.$router.resolve({
              path:item.url
            })
            window.open(routerUrl.href,"_blank")
         },
      }
  }
</script>

<style lang="scss" scoped>
.navback{
  width: 16.6%;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  margin-bottom: 70px;
  cursor: pointer;
  img{
    width: 61px;
    height: 62px;
    margin-bottom: 17px;
  }
  font-size: 22px;
}
.nav02{
  .nav02s{
    width: 100%;
    display: flex;
    flex-wrap: wrap;
  }
   .kuaijie{
    width: 216px;
    height: 27px;
    display: block;
    margin: 0 auto;
    margin-bottom: 51px;
   }
}
.search{
  width: 640px;
height: 70px;
background: #fff;
border: 1px solid #D8ECE9;
border-radius: 35px;
display: flex;
align-items: center;
.img{
  width: 24px;
  height: 25px;
  margin-left: auto;
  margin-right: 32px;
  cursor: pointer;
}
.input{
  width: 60%;
  height: 100%;
  color: #687382;
  font-size: 20px;
  margin-left: 30px;
}
::v-deep .el-input__inner{
  height: 100%;
  line-height: 70px;
  border: none;
}
}
.nav{
  width: 1250px;
  margin: 0 auto;
  padding-top: 30px;
  z-index: 2;
  background: linear-gradient(0deg, #FFFFFF, #EEFDFA);
box-shadow: 0px 0px 32px 0px rgba(25,119,100,0.13);
border-radius: 30px;
margin-top: -160px;
.nav01{
  width: 100%;
  height: 160px;
  display: flex;
  align-items: center;
  justify-content: center;
}
}
</style>



// WEBPACK FOOTER //
// src/views/index/components/nav.vue